import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { filterIsNotUndefined } from '@kaseya-utils';
import { PaymentManagementActiveFacade } from '@layout/payment-management-active/facades/payment-management-active.facade';

export const isPaymentManagementActiveGuard: CanMatchFn = () => {
  const facade = inject(PaymentManagementActiveFacade);
  const router = inject(Router);

  facade.loadPaymentManagementActive();

  return combineLatest([facade.isPaymentManagementActive$, facade.loading$, facade.error$]).pipe(
    map(([hasAccess, isLoading, hasError]) => {
      if (isLoading) {
        return undefined;
      }

      if (!hasAccess || hasError) {
        return router.createUrlTree(['access-denied']);
      }

      return true;
    }),
    filterIsNotUndefined()
  );
};
